import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import OrlenSearchbox from "./components/OrlenSearchbox";
import OrlenService from "./OrlenService";
import ReactNotify from 'react-notify';
import OrlenTable from "./components/OrlenTable";
import moment from "moment";
import DateAndTimeFormat from "../../../utilities/DateAndTimeFormat";
import OrlenRaportTable from "./components/OrlenRaportTable";


export default class OrlenContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: null,
            dane: [],
            orlenRaport: [],
            fakturyWysylkaSelect: [],
            setLoader: false,
            setLoaderRaport: false,
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
        this.onClickPobierz = this.onClickPobierz.bind(this)
        this.pobierzNumeryFaktur = this.pobierzNumeryFaktur.bind(this)
    }

    componentDidMount() {
        this.pobierzNumeryFaktur()
        // let now = moment();
        // let obecny_rok = (now.year());
        // let poprzedni_miesiac = (now.month());

        // let pierwszy_miesiaca = moment(obecny_rok + '-' + poprzedni_miesiac + '-01')
        let pierwszy_miesiaca = moment().subtract(1, "month").startOf('month')

        // let ostatni_miesiaca = moment(obecny_rok + '-' + poprzedni_miesiac + '-' + moment(now).daysInMonth())
        let ostatni_miesiaca = moment().endOf('month')

        this.onClickSzukaj({
            dataOd: DateAndTimeFormat.formatYYYYMMDD(pierwszy_miesiaca),
            dataDo: DateAndTimeFormat.formatYYYYMMDD(ostatni_miesiaca),
        })
    }

    onClickSzukaj(params) {
        this.setState({params: params, setLoader: true})
        this.pobierzRaportOrlen(params)
        OrlenService.wyswietlDaneOrlen(params).then(function (response) {
            this.setState({dane: response.data, setLoader: false})
        }.bind(this))
            .catch(function (err) {
                this.setState({setLoader: false})
            }.bind(this))
    }

    onClickPobierz(params) {
        this.setState({params: params, setLoader: true})
        OrlenService.pobierzDaneOrlen(params)
            .then(function (response) {
                this.setState({setLoader: false})
                if (response.status < 300) {
                    this.onClickSzukaj(params)
                    this.refs.notificator.success("Pomyślnie pobrano dane", "", 3000);
                } else {
                    this.refs.notificator.error("Wystąpił błąd podczas próby pobrania danych ", "", 3000);
                }
            }.bind(this))
            .catch(function (err) {
                this.refs.notificator.error("Wystąpił błąd podczas próby pobrania danych ", "", 3000);
                this.setState({setLoader: false})
            }.bind(this))
    }

    pobierzRaportOrlen(params) {
        this.setState({setLoaderRaport: true})
        OrlenService.pobierzRaportOrlen(params).then(function (response) {
            this.setState({setLoaderRaport: false})
            if (response.status < 300) {
             //   this.refs.notificator.success("Pomyślnie pobrano raport", "", 3000);
                this.setState({orlenRaport:response.data})
            } else {
                this.refs.notificator.error("Wystąpił błąd podczas próby pobrania raportu ", "", 3000);
            }
        }.bind(this))
            .catch(function (err) {
                this.refs.notificator.error("Wystąpił błąd podczas próby pobrania raportu ", "", 3000);
                this.setState({setLoaderRaport: false})
            }.bind(this))
    }

    pobierzNumeryFaktur() {
        OrlenService.pobierzNumeryFaktur().then(function (response) {
            this.setState({fakturyWysylkaSelect: response.data})
        }.bind(this))

    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RaportyContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/raporty', text: 'Raporty'}, {
                                        addressUrl: '/raporty/orlen',
                                        text: 'Orlen'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <OrlenSearchbox handleClickSearch={this.onClickSzukaj} handleClickDownload={this.onClickPobierz}
                                            fakturyWysylkaSelect={this.state.fakturyWysylkaSelect}
                                            handleOdswiezNumeryFaktur={() => {
                                                this.pobierzNumeryFaktur()
                                            }}
                            />
                        </Col>
                        <Col xs={12}>
                            {
                                Boolean(this.state.setLoader) ?
                                    <div id={'smallLoader'}>
                                        <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                        <div>Trwa pobieranie danych...</div>
                                    </div>
                                    :
                                    <OrlenTable data={this.state.dane}/>
                            }
                        </Col>
                        <Col xs={12}>
                            {
                                Boolean(this.state.setLoaderRaport) ?
                                    <div id={'smallLoader'}>
                                        <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                        <div>Trwa ładowanie raportu...</div>
                                    </div>
                                    :
                                    <div>
                                        <h2 style={{textAlign:'left', borderBottom:'1px solid #83c33a', paddingBottom:'5px'}}>Raport Orlen z okresu {Boolean(this.state.params)? this.state.params.dataOd+' - '+this.state.params.dataDo : 'wyszukanego'}</h2>
                                        <OrlenRaportTable data={this.state.orlenRaport} />
                                    </div>
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/Orlen/OrlenContainer.js